import { useMemo } from 'react'
import useRecentAirports from './useRecentAirports'
import { getAirportSuggestions } from 'lib/flights/airportSuggestions'

interface Options {
  /** Airports kept at the top of the list, e.g. the previous leg's arrival airport */
  pinnedAirports?: Array<App.AirportLocation>;
  /** Airport selected in the other direction, left out of the list */
  excludeAirport?: App.AirportLocation;
}

function useAirportSuggestions(options: Options = {}) {
  const { pinnedAirports, excludeAirport } = options
  const recentAirports = useRecentAirports()

  return useMemo(
    () => getAirportSuggestions(recentAirports, { pinnedAirports, excludeAirport }),
    [recentAirports, pinnedAirports, excludeAirport],
  )
}

export default useAirportSuggestions
